import React from "react";
import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";

const LANGS = [
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "nl", label: "Nederlands", flag: "🇧🇪" },
];

export default function LanguageSwitcher({ variant = "header" }) {
  const { i18n } = useTranslation();
  const current = (i18n.language || "fr").split("-")[0];

  const change = (code) => {
    if (code === current) return;
    i18n.changeLanguage(code);
    try { localStorage.setItem("myanimation.lang", code); } catch { /* ignore */ }
  };

  if (variant === "footer") {
    return (
      <div className="flex items-center gap-2 text-[11px] text-white/55" data-testid="lang-switcher-footer">
        <Globe size={12} strokeWidth={1.5} />
        {LANGS.map((l) => (
          <button
            key={l.code}
            type="button"
            onClick={() => change(l.code)}
            className={`uppercase tracking-[0.18em] hover:text-[#DCB457] transition ${
              current === l.code ? "text-[#DCB457]" : ""
            }`}
            data-testid={`lang-btn-${l.code}`}
          >
            {l.code}
          </button>
        )).reduce((acc, el, i) => (i ? [...acc, <span key={`s${i}`} className="text-white/20">·</span>, el] : [el]), [])}
      </div>
    );
  }

  return (
    <div className="relative group" data-testid="lang-switcher">
      <button
        type="button"
        className="flex items-center gap-1.5 text-[11px] uppercase tracking-[0.2em] text-white/70 hover:text-[#DCB457] transition px-2 py-1"
        aria-label="Language selector"
      >
        <Globe size={13} strokeWidth={1.5} />
        <span>{current.toUpperCase()}</span>
      </button>
      <div
        className="absolute right-0 top-full mt-1 min-w-[160px] bg-black/95 border border-[#DCB457]/25 opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto transition-opacity duration-150 z-50"
      >
        {LANGS.map((l) => (
          <button
            key={l.code}
            type="button"
            onClick={() => change(l.code)}
            className={`w-full text-left px-3 py-2 text-xs flex items-center gap-2 hover:bg-white/[0.04] ${
              current === l.code ? "text-[#DCB457]" : "text-white/85"
            }`}
            data-testid={`lang-select-${l.code}`}
          >
            <span aria-hidden>{l.flag}</span>
            <span>{l.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
